import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { APP1_SELECTOR, APP2_SELECTOR } from '@/utils'
import { StyleProvider } from '@ant-design/cssinjs'

const App1 = React.lazy(() => import('./App1'))
const App2 = React.lazy(() => import('./App2'))

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 0,
		},
	},
})

function initApps() {
	const app1Selector = (APP1_SELECTOR as string) || '#my_app'
	const app2Selector = (APP2_SELECTOR as string) || '#my_app_metabox'
	const app1Nodes = document.querySelectorAll(app1Selector)
	const app2Nodes = document.querySelectorAll(app2Selector)

	const mapping = [
		{
			els: app1Nodes,
			App: App1,
		},
		{
			els: app2Nodes,
			App: App2,
		},
	]

	mapping.forEach(({ els, App }) => {
		if (els && els.length > 0) {
			els.forEach((el) => {
				// Check if already rendered
				if (el.hasChildNodes()) {
					return
				}
				ReactDOM.createRoot(el).render(
					<React.StrictMode>
						<QueryClientProvider client={queryClient}>
							<StyleProvider hashPriority="low">
								<App />
							</StyleProvider>
							<ReactQueryDevtools initialIsOpen={false} />
						</QueryClientProvider>
					</React.StrictMode>,
				)
			})
		}
	})
}

// Try immediately (in case DOM is already ready)
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initApps)
} else {
	// DOM is already ready
	initApps()
}

// Also try after a short delay to catch dynamically added elements
setTimeout(initApps, 100)
